import { Link } from "gatsby";
import React from "react";

const OrangeStrip = () => {
  return (
    <div className="">
      <div className="w-full bg-GlobalContact bg-cover bg-no-repeat mx-auto py-7 px-8 md:px-12 text-white">
        <div
          className=" flex flex-col lg:flex-row md:items-center justify-around"
          style="margin: 2% 10%;"
        >
          <div className="text-[28px] w-full lg:w-[60%]">
            {/* <h2 className="font-bold">  Contact Us 24/7 </h2> */}
            <p className="text-center sm:text-left font-secondary">
              {" "}
              Translating a WordPress website? Tomedes is one of the official
              suppliers of WPML
            </p>
          </div>
          <div className="my-8 md:my-0 w-full pt-4 lg:pt-0 lg:w-[30%] flex justify-center mx-auto">
            <Link
              to="https://www.tomedes.com/wpml-wordpress-website-translation"
              className="font-opensans font-semibold text-17 text-center uppercase rounded-full bg-[#000C27] text-white cursor-pointer  py-4 px-8 w-[253px] hover:bg-[#012A68]"
            >
             LEARN MORE
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrangeStrip;
